"use client";
import {
  popover
} from "./chunk-ZSJ4VP4I.mjs";
import {
  TriggerIcon
} from "./chunk-IRWCI664.mjs";

// src/components/tooltip-trigger.tsx
import { jsx } from "react/jsx-runtime";
var TooltipTrigger = /* @__PURE__ */ jsx("button", { type: "button", className: popover().tooltipTrigger(), children: /* @__PURE__ */ jsx(TriggerIcon, {}) });
var tooltip_trigger_default = TooltipTrigger;

export {
  tooltip_trigger_default
};
